// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__wVNNv","col":"styles_col__AwJMv"};